/* eslint-disable max-len */
/* eslint-disable no-console */
// EmptyDrawer.js
import React, { useContext, useEffect, useState } from 'react';
import { Drawer, Box, Typography, Grid, Stack, IconButton, Avatar, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RemindCard from '../../../../components/Common/ReminderCard/RemindCard';
import { FaClock } from 'react-icons/fa';
import AddIcon from '@mui/icons-material/Add';
import SetReminderSlider from './SetReminder';
import { LanguageContext } from '../../../../libs/Context';
import { getReminders } from '../../../../containers/actions/chat_actions';
import { queryParams } from '../../../../libs/HelperContent';
import { useSelector } from 'react-redux';
import ProfilePic from '../../../../components/Common/ProfilePic';
import NoData from '../../../../components/Common/NoData';

interface iReminderStateProps
{
	showReminder : boolean;
	isLoding : boolean;
	reminderData: any[];
	reminderCount: number;
	skip: number;
	itemPerPage: number;
}

const ReminderSlider = ({ open, onClose }) =>
{
	const { language } = useContext(LanguageContext);
	const session = useSelector((state:any) => state?.mysession?.session);
	const userData = useSelector((state:any) => state?.mysession?.session);

	const queryParamRes = queryParams(session?.userId, session?.companyId, session?.empRole, session?.role, 'get');

	// State
	const [ reminderAction, setReminderAction ] = useState<iReminderStateProps>({
		showReminder  : false,
		isLoding      : false,
		reminderData  : [],
		reminderCount : 0,
		skip          : 0,
		itemPerPage   : 12
	});

	const { showReminder, isLoding, reminderData, reminderCount } = reminderAction;

	// get reminder list on intital render
	const getReminderList = async () =>
	{
		setReminderAction((prev) => ({
			...prev,
			isLoding : true
		}));
		try
		{
			let query = `?limit=${12}&skip=0&tab=all`;

			if (queryParamRes)
			{
				query += `${queryParamRes}`;
			}
			// API call to get reminder list
			const result = await getReminders(query);

			if (result?.data)
			{
				if (result?.data?.length >= 12 && reminderAction.skip === 0)
				{
					query += '&count=true';
					const listCount = await getReminders(query);

					setReminderAction((prev) => ({
						...prev,
						reminderCount : listCount.count
					}));
				}
				else if (result?.data && result?.data.length < 12 && reminderAction.skip === 0)
				{
					setReminderAction((prev) => ({
						...prev,
						reminderData  : result?.data,
						reminderCount : result?.data?.length
					}));
				}
			}
		}
		catch (err:any)
		{
			console.log(err, 'error');
		}
		finally
		{
			setReminderAction((prev) => ({
				...prev,
				isLoding : false
			}));
		}
	};

	useEffect(() =>
	{
		getReminderList();
	}, []);

	// Stregic actions
	const handleShowReminder = () =>
	{
		setReminderAction((prev) => ({
			...prev,
			showReminder : true
		}));
	};
	const handleReminderClose = () =>
	{
		setReminderAction((prev) => ({
			...prev,
			showReminder : false
		}));
		onClose();
	};

	const selfRemindersData = reminderData?.flatMap((reminder) =>
		(Array.isArray(reminder.reminderTo)
			? reminder.reminderTo
				.filter((user) => user && user.userId)
				.map((user) => ({
					reminderId       : reminder._id,
					reminderTitle    : reminder.title,
					reminderDateTime : reminder.reminderDateTime,
					userId           : user.userId,
					userName         : user.firstName,
					userEmail        : user.email,
					companyName      : user.companyName,
					reminderType     : reminder.reminderType,
					createdBy        : reminder.createdBy?.firstName
				}))
			: [])
	) ?? [];

	const isUserMatched = selfRemindersData.length > 0 && userData?.userId === selfRemindersData[0].userId;

	console.log('*****************flattenedReminders', selfRemindersData);

	return (
		<>
			<Drawer anchor='right' open={open} onClose={onClose} PaperProps={{
				sx : {
					width : {
						xs : '100%',
						sm : '70%',
						md : '30%',
						lg : '30%'
					},
					display       : 'flex',
					flexDirection : 'column'
				}
			}}
			>
				<Grid container display={'flex'} flexDirection={'column'} role='presentation' sx={{ position : 'relative',
					height   : '100%' }}
				>
					<Grid item sx={{ background: '#F2F2F2', position: 'sticky', top: 0, zIndex: 999 }}>
						<Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} p={2}>
							<Typography fontSize={'20px'} fontWeight={500} color={'#212121'}>
								{language?.reminders} {reminderCount > 0 ? `(${reminderCount})` : '0'}
							</Typography>
							<IconButton onClick={onClose}>
								<CloseIcon sx={{ fontSize: '24px', color: '#212121' }} />
							</IconButton>
						</Stack>
					</Grid>
					{ isUserMatched
						? (<Grid item xs minHeight={0} display={'flex'} flexWrap={'nowrap'} direction={'column'} container>
							<Grid item p={3}>
								<Box sx={{ boxShadow: ' 8px 8px 8px #0000001A', borderRadius: '13px' }}>
									<RemindCard/>
								</Box>
							</Grid>
							<Grid item px={3} py={1} mb={1} justifyContent={'start'} alignItems={'center'}>
								<Typography fontSize={'18px'} fontWeight={600} color={'#283C50'}>
									{language?.upcomingReminders}&nbsp;{reminderCount > 0 ? `(${reminderCount})` : '0'})
								</Typography>
							</Grid>
							<Grid item minHeight={0} direction='column' sx={{ overflowY: 'auto' }}>
								<Grid item container xs={12} direction='row' px={3} pb={1}>
									{selfRemindersData?.map((item, index) => (
										<Grid
											item
											xs={12}
											key={index}
											p={1}
											mb={2}
											sx={{
												border       : '1px solid #D6D4D4',
												borderRadius : '13px',
												paddingY     : '8px'
											}}
											display='flex'
											justifyContent='start'
											gap={1}
										>
											<Box sx={{ width: '36px', height: '36px', backgroundColor: 'var(--black0)', color: 'var(--black08)', borderRadius: '50%' }}>
												<ProfilePic
													imagePath={`${item.userId}.jpeg`}
													defaultImg='/images/icons/defaultUser.svg'
													alt='profileimg'
													className='brdrRadius50'
													from='selfProfile'
												/>
											</Box>

											<Stack direction='column' spacing={0.5}>
												<Typography fontSize={16} fontWeight={600} color='#283C50'
													sx={{
														overflow     : 'hidden',
														textOverflow : 'ellipsis',
														whiteSpace   : 'nowrap',
														maxWidth     : 'var(--font200)'
													}}
												>
													{item.reminderTitle || 'No Title'}
												</Typography>

												<Stack direction='row' spacing={1} alignItems='center' justifyContent='start'>
													<FaClock color='#FD907E' fontSize={14} />
													<Typography fontSize={14} fontWeight={500} color='#212121'>
														{new Date(item.reminderDateTime).toLocaleString()}
													</Typography>
												</Stack>
											</Stack>
										</Grid>
									))}
								</Grid>
							</Grid>
						</Grid>)
						: (<NoData />)}
					<Grid item px={2} py={2} sx={{ background: '#fff', position: 'sticky', bottom: 0, zIndex: 999 }} display={'flex'} justifyContent={'end'}>
						<Button
							variant='contained'
							aria-label='add'
							sx={{
								borderRadius : '4px',
								boxShadow    : 'none',
								color        : '#fff'
							}}
							startIcon={<AddIcon />}
							onClick={handleShowReminder}
						>
							{language?.setReminder}
						</Button>
					</Grid>
				</Grid>
			</Drawer>
			{showReminder &&
			<SetReminderSlider
				open={showReminder}
				onClose={handleReminderClose}
			/>}
		</>
	);
};

export default ReminderSlider;
